import { ProfileSection } from "@/components/profile/ProfileSection";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "@/auth/authSlice";
import { updateUserProfile } from "@/state/profileSlice";
import { LogOut } from "lucide-react";
import { TranslatedText } from "@/components/common/text";
import { ThemeSwitcher } from "@/components/profile/ThemeSwitcher";
import { ProfileDropdown } from "@/components/profile/ProfileDropdown";
import { TitleButton } from "@/components/profile/TitleButton";
import { useEffect, useState } from "react";
import { LanguageTypes, trailerTypes } from "@/utils/constants";

export const Profile = () => {
    const user = useSelector((state) => state.user);
    const profile = useSelector((state) => state.profile);
    const dispatch = useDispatch();
    const [editMode, setEditMode] = useState(null);

    const handleLogout = () => {
        dispatch(logoutUser());
    };

    const themeSwitch = <ThemeSwitcher />;

    useEffect(() => {
        if (!profile.loading && !profile.updateError) {
            setEditMode(null);
        }
    }, [profile.loading]);

    return (
        <div className="flex flex-col pt-16 pl-6 md:pl-[150px] w-full pr-6 justify-start items-start">
            <ProfileSection title="Account">
                <div className="mt-[-8px] text-cm-p-text-secondary text-lg font-medium">{user?.data?.email}</div>
            </ProfileSection>
            <ProfileSection title="Language" nextToTitle={<TitleButton type="language" editMode={editMode} setEditMode={setEditMode} />}>
                {editMode === "language" ? (
                    <ProfileDropdown
                        initialValue={profile.data?.appLanguage}
                        items={LanguageTypes}
                        saveValue={(value) => {
                            dispatch(updateUserProfile({ ...profile.data, appLanguage: value }));
                        }}
                        loading={profile.loading}
                    />
                ) : (
                    <div className="text-cm-p-text-secondary text-lg font-medium">{profile.data?.appLanguage.text}</div>
                )}
            </ProfileSection>
            <ProfileSection title="Dark theme" nextToTitle={themeSwitch} />
            <ProfileSection
                title="Default trailer type"
                nextToTitle={<TitleButton type="trailerType" editMode={editMode} setEditMode={setEditMode} />}
            >
                {editMode === "trailerType" ? (
                    <ProfileDropdown
                        initialValue={profile.data?.trailerType}
                        items={trailerTypes}
                        saveValue={(value) => {
                            dispatch(updateUserProfile({ ...profile.data, trailerType: value }));
                        }}
                        loading={profile.loading}
                    />
                ) : (
                    <div className="text-cm-text-secondary text-lg font-medium">{profile.data?.trailerType.text}</div>
                )}
            </ProfileSection>
            {profile.updateError && <div className="text-cm-error my-4">{profile.updateError}</div>}
            <button className="text-center flex gap-2 text-cm-red items-center justify-center" onClick={handleLogout}>
                <LogOut />
                <TranslatedText>Sign out</TranslatedText>
            </button>
        </div>
    );
};
